import {Brick, ListDef, QueryResult, registerBrick, ErrorFlow} from 'olympe';
import {forEachWithErrorFlowLambda, toErrorFlow} from '../functionSignatures';

export default class ForEachWithErrorFlow extends Brick {
    /**
     * @protected
     * @param {!BrickContext} $
     * @param {!ListDef|![]|!QueryResult} list
     * @param {!Brick} iterator
     * @param {!function()} forwardEvent
     * @param {!function(ErrorFlow)} setErrorFlow
     */
    async update($, [list, iterator], [forwardEvent, setErrorFlow]) {
        if (!list || !iterator) {
            console.warn('Nothing to do: list or iterator is null or undefined.');
            forwardEvent();
            return;
        }

        let array = [];
        if (Array.isArray(list)) {
            array = list;
        } else if (list instanceof QueryResult) {
            array = list.toArray();
        } else if (list instanceof ListDef) {
            list.forEachCurrentValue((item) => array.push(item));
        } else {
            console.error('The provided list must be of type ListDef, Array or QueryResult');
            return;
        }

        try {
            for (let i = 0, l = array.length; i < l; i++) {
                if ($.isDestroyed()) {
                    setErrorFlow(ErrorFlow.create('For each context has been destroyed', 1));
                    return;
                }
                await forEachWithErrorFlowLambda($, iterator, array[i], i, array);
            }
            forwardEvent();
        } catch (e) {
            // Re-create the ErrorFlow so the one from the iterator context (destroyed by now) is not reused as-is
            const errorFlow = toErrorFlow(e);
            setErrorFlow(ErrorFlow.create(errorFlow.getMessage(), errorFlow.getCode()));
        }
    }
}

registerBrick('0199bee928b5a514bba6', ForEachWithErrorFlow);
